import { CommonResponse } from "types/types";
import { axiosPost, axiosGet, axiosDelete } from "../../../axios/axios-config";
import { AxiosResponse } from "axios";
import { PaymentMethod } from "@stripe/stripe-js";

export const createStripeCustomerRequest = async (data: {
  user_id: number;
  paymentMethod?: PaymentMethod;
}): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPost("/payment/api/create-stripe-customer/", data);
};

export const retriveCustomerPaymentMethodsRequest = async (
  customer_id: string
): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosGet(
    `/payment/api/retrive-customer-paymentmethod/${customer_id}`
  );
};

export const createPaymentIntentRequest = async (data: {
  user_id: number;
  payment_method_id: string;
  amount?: number;
  currency?: string;
}): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPost("/payment/api/create-payment-intent/", data);
};

export const createStripePaymentRecordRequest = async (data: {
  user_id: number;
  payment_reference_id: string;
  payment_method_id: string;
  status: string;
  amount?: number;
  currency?: string;
  country_id?: number;
  isGift?: boolean;
}): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPost("/payment/api/create-stripe-payment-record/", data);
};

export const addNewPurchasedBitRequest = async (bitDetail: {
  user: number;
  payment?: number;
  country: number;
  bit: number;
  coordinates: { row: number; col: number }[];
}): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPost("/map-bit/purchased_bit/", bitDetail, {}, () => { });
};

export const validateCouponRequest = async (data: {
  user_id: number;
  code: string;
  totalSelectedBits: number;
}): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPost("/payment/api/validate-coupon/", data);
};

export const removeCouponRequest = async (data: {
  code: string;
}): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosDelete("/payment/api/validate-coupon/", data);
};

export const detachPaymentMethodRequest = async (data: {
  payment_method_id: string;
}): Promise<void | AxiosResponse<CommonResponse>> => {
  return await axiosPost("/payment/api/detach-payment-method/", data);
};